import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PROFILE_UI_TRANSLATIONS_KEY } from "../constants";
var es = /*#__PURE__*/_defineProperty({}, PROFILE_UI_TRANSLATIONS_KEY, {
  PROFILE_ACCOUNT: 'Cuenta',
  PROFILE_NIGHTSWITCH: 'Modo Nocturno',
  PROFILE_COMPANY: 'Compañía',
  PROFILE_PANEL: 'Panel',
  PROFILE_LOGOUT: 'Cerrar sesión',
  PROFILE_PROFESSOR: 'Profesor',
  PROFILE_MENTOR: 'Mentor',
  PROFILE_ADMIN: 'Administrador',
  PROFILE_LEADER: 'Líder',
  PROFILE_SUPERVISOR: 'Supervisor',
  PROFILE_MEMBER: 'Colaborador',
  PROFILE_COURSES: 'Mis cursos',
  PROFILE_PROFILE: 'Mi Perfil',
  PROFILE_MANAGE_ACCOUNT: 'Configurar cuenta',
  PROFILE_HELP_CENTER: 'Centro de ayuda',
  PROFILE_CONFIGURATION: 'Configuración',
  PROFILE_MENTORS: 'Mentores',
  SWITCHER_SUPPLANTED: 'Suplantando a:',
  SWITCHER_EXIT: 'Salir de suplantación',
  SWITCHER_EXIT_MY_ACCOUNT: 'Mi cuenta',
  SWITCHER_EXIT_ERROR: 'No se puedo ejecutar la acción. Por favor, inténtalo más tarde.',
  SWITCHER_EXIT_SUCCESS: 'Se ha salido de la suplantación correctamente, espera un momento.',
  // Company Selector
  COMPANY_LABEL: 'COMPAÑÍA',
  COMPANY_PLACEHOLDER: 'Selecciona una compañía',
  COMPANY_SEARCH_PLACEHOLDER: 'Buscar',
  COMPANY_NO_RESULTS_TITLE: 'No se encontraron compañías',
  COMPANY_NO_RESULTS_SUBTITLE: 'Intenta ajustar tus criterios de búsqueda',
  COMPANY_CORPORATE: 'Corporativo',
  COMPANY_SUBSIDIARY: 'Compañía hija'
});
export default es;